/**
 *
 * Asynchronously loads the component for ProductPage
 *
 */

import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("./index"),
  loading: () => null
});
